<section class="cta">
  <div class="glow"></div>
  <div class="wl-inner inner">
    <p class="eyebrow">Gotowi?</p>
    <h2 class="title">Niech goście wspominają<br>to wesele.</h2>
    <p class="sub">Przygotuj swoją grę w 10 minut.</p>
    <a routerLink="/admin/kreator" class="btn">Zacznij za darmo</a>
  </div>
</section>
